import { QueryKeys, queryClient } from "@/api/core";
import { SearchQueryKeys } from "@/api/search/query-keys";
import { statusSchema, type Status } from "@/schemas";
import { updateQueryData } from "@/utils/queries";

interface NextStatusParams extends Partial<Status> {}

function updateStatusCache(
  statusId: string,
  getNextStatusParams: (prevStatus: Status) => NextStatusParams,
): [prevStatus: Status | undefined, nextStatus: Status | undefined] {
  let nextStatus: Status | undefined = undefined;
  const queryKey = QueryKeys.statuses.detail(statusId);
  let prevStatus = queryClient.getQueryData(queryKey) as Status | undefined;

  if (!prevStatus) {
    // If we don't have a status from the details cache key, let's find the
    // global status instead.
    prevStatus = (
      queryClient.getQueryData(QueryKeys.statuses.global) as Status[]
    ).find((entity) => entity.id === statusId);
  }

  if (prevStatus) {
    nextStatus = {
      ...prevStatus,
      ...getNextStatusParams(prevStatus),
    };

    queryClient.setQueryData(queryKey, nextStatus);

    const prevParentStatuses = queryClient.getQueryData(
      QueryKeys.statuses.global,
    ) as Status[] | undefined;
    if (prevParentStatuses) {
      prevParentStatuses
        .filter((parentStatus) => parentStatus.reblog?.id === statusId)
        .forEach((parentStatus) => {
          updateQueryData(QueryKeys.statuses.global, {
            ...parentStatus,
            reblog: nextStatus,
          });
        });
    }
    // Update status in all cached lists
    updateQueryData(QueryKeys.statuses.global, nextStatus);
    updateQueryData(SearchQueryKeys.global, nextStatus, statusSchema);
  }

  return [prevStatus, nextStatus];
}

export { updateStatusCache };
